module.exports = __webpack_public_path__ + "static/image/logo-family/logo_music.ver2_0_2.png?0d29e8b1";